var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { USER_ADD_SUCCESS } from './user.actions';
import { NgxPermissionsService } from 'ngx-permissions';
import { map, tap } from 'rxjs/operators';
var UserEffects = /** @class */ (function () {
    function UserEffects(actions$, permissionsService) {
        var _this = this;
        this.actions$ = actions$;
        this.permissionsService = permissionsService;
        this.userAddSuccess$ = this.actions$.pipe(ofType(USER_ADD_SUCCESS), map(function (action) { return action.payload; }), tap(function (user) {
            _this.permissionsService.loadPermissions(user.permissions);
        }));
    }
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], UserEffects.prototype, "userAddSuccess$", void 0);
    return UserEffects;
}());
export { UserEffects };
